import React, { useEffect } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";

import "../styles/home.css";
import useWindowDimensions from "../constatns/size";
import TokenChartDetail from "../components/tokenomics/TokenChartDetail";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import GrTitle, { Title } from "../components/BgTitle";


function Tokenomics() {
    const { width, height } = useWindowDimensions();

  useEffect(()=>{
    let root = am5.Root.new("chartdiv");

  // Set themes
  // https://www.amcharts.com/docs/v5/concepts/themes/
  root.setThemes([
    am5themes_Animated.new(root)
  ]);

  // Create chart
  // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/
    let chart = root.container.children.push(am5percent.PieChart.new(root, {
      layout: root.verticalLayout,
      
    }));

    

  // Create series
  // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Series
    let series = chart.series.push(am5percent.PieSeries.new(root, {
      valueField: "value",
      categoryField: "category",
      fillField: "color",
    }));

    series.labels.template.set("fill", colors.primary)


    // series.labels.watermark.text = "My awesome chart © 2018 Myself";


// Set data
// https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Setting_data
    series.data.setAll([
      { value: 5, category: "Private Sale", color: colors.btnPrimary },
      { value: 5, category: "Presale", color: colors.btnPrimary },
      { value: 10, category: "Public Sale", color: colors.btnPrimary },
      { value: 12, category: "Airdrops+Rewards", color: colors.btnPrimary },
      { value: 20, category: "Team", color: colors.primaryLight },
      { value: 18, category: "Company Reserve", color: colors.btnPrimary },
      { value: 10, category: "Advisory", color: colors.btnPrimary },
      { value: 20, category: "Liquidity pool", color: colors.btnPrimary },
    ]);


// Play initial series animation
// https://www.amcharts.com/docs/v5/concepts/animations/#Animation_of_series

    let subscribe = ()=>{
      var elementTarget = document.getElementById("roadmap");
      if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight) ) {
          series.appear(5000, 100);
          window.removeEventListener("scroll", subscribe);
      }
    }

    window.addEventListener("scroll", subscribe);

    return () => {
      window.removeEventListener("scroll", subscribe);
      root.dispose();
    }
  }, [])

  const styleScroll =  width <= 768 ? {
    // overflow: "auto",
    // whiteSpace: "nowrap",
    display: "block",
  } : {};
    
  return (
      <div id="tokenomics">
        <GrTitle bgTitle={"TOKENOMICS"}/>
        <Title title={"GEAR TOKEN"}/>
        <Description>
            Breakdown of our token recipients.
        </Description>
        <Container width={width} height={height} >
            <ContainerBox >
                <InnerContainer style={{position: "relative"}}>
                    <div style={{position: "absolute", backgroundColor: colors.primary, borderTopRightRadius: 40, zIndex: 99,  bottom: 0, width: 60, height: 90}}/>
                    
                        <PieChart width={width} height={height} id="chartdiv"/>
                </InnerContainer>
                <InnerContainer style={{  marginLeft: width <= 768 ? 0 : width * 0.01, ...styleScroll}}>
                    <InnerContainer style={{flexDirection: "column"}}>
                        <TokenChartDetail
                            title={"Private Sale"}
                            description={"5%"}
                        />

                        <TokenChartDetail
                            title={"Public Sale"}
                            description={"10%"}
                        />

                        <TokenChartDetail
                            title={"Team"}
                            description={"20%"}
                            subDescription={"(Cliff 12, Vesting 24)"}
                        />

                        <TokenChartDetail
                            title={"Advisor & Partners"}
                            description={"10%"}
                            subDescription={"(Cliff 6, Vesting 12)"}
                        />
                        
                    </InnerContainer>
                    <InnerContainer style={{flexDirection: "column", marginLeft: width <= 768 ? 0 : width * 0.04}}>
                        
                        <TokenChartDetail
                            title={"Presale"}
                            description={"5%"}
                        />
                        <TokenChartDetail
                            title={"Airdrops+Rewards"}
                            description={"12%"}
                            titleStyle={{color: colors.btnPrimary}}
                        />

                        <TokenChartDetail
                            title={"Company Reserve"}
                            description={"18%"}
                        />

                        <TokenChartDetail
                            title={"Liquidity pool"}
                            description={"20%"}
                            
                        />
                    </InnerContainer>
                </InnerContainer>
            </ContainerBox>
        </Container>
        
    </div>
  );
}

const Container = styled.div`
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    padding-bottom: 100px;
    color: white;
`

const InnerContainer = styled.div`
    display: flex;
    color: ${colors.white};

`

const PieChart = styled.div`
    width: ${({width})=> width/2.8}px;
    height: ${({width})=> width/2.8}px;
    color: ${colors.white};


    @media (max-width: 768px) {
        width: ${({width})=> width/1.2}px;
        height: ${({width})=> width/1.2}px;
    }
`

const Description = styled.p`
    color: ${colors.grey};
    text-align: center;
`

const ContainerBox = styled.div`
    display: flex;
   

    @media (max-width: 768px) {
        display: block;
        
    }
`

export default Tokenomics;